import React from "react";

/**
 * Eyebrow + h2 + optional lede.
 *
 * The eyebrow is decorative framing, not a heading, so it stays a <p> — that
 * keeps the h1 -> h2 -> h3 order on the page unbroken.
 */
export default function SectionHeading({
  eyebrow,
  title,
  sub,
  tone = "light",
  align = "left",
  className = "",
}) {
  const dark = tone === "dark";

  return (
    <div
      className={`landing-reveal ${
        align === "center" ? "mx-auto text-center" : ""
      } max-w-3xl ${className}`}
    >
      {eyebrow && (
        <p
          className={`text-sm font-medium uppercase tracking-wide ${
            dark ? "text-blue-landing" : "text-primary"
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        className={`mt-3 text-3xl font-bold leading-tight md:text-4xl ${
          dark ? "text-white" : "text-black-landing"
        }`}
      >
        {title}
      </h2>
      {sub && (
        <p
          className={`mt-4 text-lg leading-relaxed ${
            dark ? "text-gray-200" : "text-muted"
          }`}
        >
          {sub}
        </p>
      )}
    </div>
  );
}
